import { gameProviderTypes } from '@configs/layout';

// Account Manager - Team Manager 화면 전환 타입
export enum teamManagerViewType {
  teamList = 'teamList',
  memberList = 'memberList',
}

export enum appManagerView {
  addMyApp = 'addMyApp',
  addCompetitorApps = 'addCompetitorApps',
}

export enum alertCreateType {
  app = 'App',
  publisher = 'Publisher',
  category = 'Category',
}

export enum alertPeirodType {
  daily = 'Daily',
  weekly = 'Weekly',
  monthly = 'Monthly',
}

export enum alertClassType {
  dailyStats = 'Daily Stats',
  featuredApps = 'Featured Apps',
  topApps = 'Top Apps',
  categoryRanking = 'Category Ranking',
  userKeywords = 'User Keywords',
  mostMentionedKeywords = 'Most Mentioned Keywords',
  currentVersionReviews = 'Current Version Reviews',
  biggestMovers = 'Biggest Movers',
  biggestLosers = 'Biggest Losers',
  newApps = 'New Apps',
}

export enum alertTypeObj {
  listBox = 'listBox',
  createBox = 'createBox',
  historyBox = 'historyBox',
}

export const alertCreateBoxRenderArr = () => {
  const alertTypeArr = []; // [{name, value: text}]
  const alertPeirodTypeArr = []; // [{name, value: text}]
  const alertClassArr = {}; // {app: [{name, value, text},{}], publisher: [{},...], ...}

  for (const key in alertCreateType) {
    let tempObj = Object.assign({}, { name: key, value: key, text: alertCreateType[key] });
    alertTypeArr.push(tempObj);
    alertClassArr[key] = [];
  }

  for (const key in alertPeirodType) {
    let tempObj = Object.assign({}, { name: key, value: key, text: alertPeirodType[key] });
    alertPeirodTypeArr.push(tempObj);
  }

  for (const key in alertClassType) {
    switch (key) {
      case 'dailyStats':
        alertClassArr['app'].push(Object.assign({}, { name: key, value: key, text: alertClassType[key] }));
        break;
      case 'featuredApps':
      case 'topApps':
      case 'categoryRanking':
      case 'userKeywords':
      case 'mostMentionedKeywords':
      case 'currentVersionReviews':
        alertClassArr['publisher'].push(Object.assign({}, { name: key, value: key, text: alertClassType[key] }));
        break;
      case 'biggestMovers':
      case 'biggestLosers':
      case 'newApps':
        alertClassArr['category'].push(Object.assign({}, { name: key, value: key, text: alertClassType[key] }));
        break;
      default:
        break;
    }
  }

  return {
    alertTypeArr,
    alertPeirodTypeArr,
    alertClassArr,
    alertStoreTypeArr: [
      {
        name: gameProviderTypes.AppleAppStore,
        value: gameProviderTypes.AppleAppStore,
        text: 'App Store',
      },
      {
        name: gameProviderTypes.GooglePlayStore,
        value: gameProviderTypes.GooglePlayStore,
        text: 'Google Play Store',
      },
    ],
  };
};

// alertHistory select tag arr //[{value: '', text: ''}]
export const alertHistoriesArrs = () => {
  const selectAlertClassArr = [];
  const selectTypeArr = [];
  const selectStore = [];

  // selectAlertClassArr
  for (const key in alertClassType) {
    const tempObj = Object.assign({}, { value: key, text: alertClassType[key] });
    selectAlertClassArr.push(tempObj);
  }

  // selectTypeArr
  for (const key in alertCreateType) {
    const tempObj = Object.assign({}, { value: key, text: alertCreateType[key] });
    selectTypeArr.push(tempObj);
  }

  // selectStore
  for (const key in gameProviderTypes) {
    const tempObj = Object.assign({}, { value: gameProviderTypes[key], text: key });
    selectStore.push(tempObj);
  }

  return {
    selectAlertClassArr,
    selectTypeArr,
    selectStore,
  };
};
